import React from 'react';
import { Popover } from 'antd';
import { buildChatThemeCssVars } from '../theme/themeCssVars.js';

function mergeClassName(...classNames) {
  return classNames.filter(Boolean).join(' ');
}

/**
 * Render sidebar popovers through one FLARE-styled boundary.
 *
 * @param {object} props - Sidebar action popover props.
 * @returns {React.ReactElement} Themed sidebar popover.
 */
export default function SidebarActionPopover({
  children,
  classNames = {},
  content,
  styles = {},
  themeTokens,
  ...popoverProps
}) {
  const themeCssVars = buildChatThemeCssVars(themeTokens);
  const sidebarPopoverVars = {
    ...themeCssVars,
    '--flare-sidebar-action-popover-bg': themeTokens?.panelBg,
    '--flare-sidebar-action-popover-border': themeTokens?.divider,
    '--flare-sidebar-action-popover-input-bg': themeTokens?.surfaceBg,
  };
  const resolvedRootClassName = mergeClassName('flare-sidebar-action-popover', classNames.root);
  const resolvedPanelClassName = mergeClassName('flare-sidebar-action-popover-panel', classNames.container);

  return (
    <Popover
      {...popoverProps}
      classNames={{
        ...classNames,
        root: resolvedRootClassName,
        container: resolvedPanelClassName,
      }}
      content={content}
      styles={{
        ...styles,
        root: {
          ...sidebarPopoverVars,
          ...styles.root,
        },
      }}
    >
      {children}
    </Popover>
  );
}
